import DisplayFields from "./DisplayFields";

export default DisplayFields;
